import { StateService } from '@uirouter/angular';
import {Component, Input, OnInit} from '@angular/core';
import {CplItem} from '../../../model/cpl-item.model';
import {UntypedFormArray, UntypedFormBuilder} from '@angular/forms';
import {UserAssignment} from '../../../supervision-management/compliance-items/compliance-item/enums/user-assignment.enum';
import {CycleType} from '../../../supervision-management/compliance-items/compliance-item/enums/cycle-type.enum';
import {ReminderType} from '../../../supervision-management/compliance-items/compliance-item/enums/reminder-type.enum';
import {ReminderFor} from '../../../supervision-management/compliance-items/compliance-item/enums/reminder-for-type.enum';
import {CplReminder} from '../../../model/cpl-reminder.model';
import {DomSanitizer} from '@angular/platform-browser';
import {FileService} from '../../../services/file.service';
import {FileAttachment} from '../../../model/file-attachment.model';
import {UnitOfMeasure} from '../../../supervision-management/compliance-items/compliance-item/enums/unit-of-measure.enum';
import {ScheduleType} from '../../../supervision-management/compliance-items/compliance-item/enums/schedule-type.enum';
import {CompletionType} from '../../../supervision-management/compliance-items/compliance-item/enums/completion-type.enum';
import {OccurrenceType} from '../../../supervision-management/compliance-items/compliance-item/enums/occurrence-type.enum';
import { A48HelpersService } from 'src/app/services/a48-helpers/a48-helpers.service';
import { CplA48Labels } from 'src/app/model/cpl-a48-labels.model';
import { CommonArrayValidators, FileDownloadHandler, PortalSettings, SessionService } from '@edl-development/edl-common';
@Component({
    selector: 'compliance-item-summary',
    templateUrl: './compliance-item-summary.component.html',
    styleUrls:   ['../../shared-compliance-items.scss']
})
export class ComplianceItemSummaryComponent implements OnInit {
    @Input() complianceItem: CplItem;
    @Input() printMode: boolean;

    reminders: UntypedFormArray;
    ReminderType = ReminderType;
    ReminderFor = ReminderFor;
    UserAssignment = UserAssignment;
    CycleType = CycleType;

    portalSettings:PortalSettings;

    A48Labels: CplA48Labels;

    UnitOfMeasure = UnitOfMeasure;
    ScheduleType = ScheduleType;
    CompletionType = CompletionType;
    OccurrenceType = OccurrenceType;


    constructor(
        public a48HelpersService: A48HelpersService,
        private formBuilder: UntypedFormBuilder,
        private sessionService: SessionService,
        public sanitizer: DomSanitizer,
        private stateService: StateService,
        private fileService: FileService,
        private fileHandler: FileDownloadHandler,
    ) {}

    ngOnInit() {

        this.portalSettings = this.sessionService.PortalSettings;

        if(this.isAct48Enabled()){
            this.A48Labels = this.a48HelpersService.getAct48DetailsLabels(this.complianceItem.Act48Detail);
        }

        this.reminders = new UntypedFormArray([]);

        if (this.complianceItem.Reminders) {
            this.complianceItem.Reminders.map((reminder: CplReminder) => {
                let item = this.formBuilder.group({
                    ReminderID: [reminder.ReminderID, []],
                    ReminderType: [reminder.ReminderType, []],
                    ReminderFor: [ReminderFor.SUBMISSION, []],
                    ItemID: [reminder.ItemID, []],
                    UOM: [reminder.UOM, []],
                    Frequency: [reminder.Frequency, []],
                    Targets: this.formBuilder.array(reminder.Targets, CommonArrayValidators.emptyArrayValidator()),
                    Limit: [reminder.Limit, []]
                });

                this.reminders.push(item);
            });
        }
    }

    getColumnWidths = () => {
        return this.printMode ? 'col-6' : 'col-md-12 col-lg-6';
    }
    
    isAct48Enabled(){
        return this.portalSettings.Act48Enabled && this.complianceItem.Act48Detail != null && this.complianceItem.Act48Detail.Applicable;
    }

    viewAttachement(attachment: FileAttachment) {
        this.fileService
            .getFileResponse(attachment.FileID)
            .subscribe((fileResponse : Blob) => {
                this.fileHandler.saveFile(fileResponse, attachment.FileName);
            });
    }

    previewQuestionnaire(){
        this.stateService
            .go('authenticated.questionnaires.questionnaire.preview', {
                questionnaireId: this.complianceItem.QfmID
            }, {reload:true});

    }
}